module.exports = __webpack_public_path__ + "static/blog_og-86f41dc825ed3573fe545e68b0af4e98.png";